export default function(fileUrl) {
  if (!fileUrl) {
    return
  }

  const patt1 = /\.([0-9a-z]+)(?:[\?&|#]|$)/i // eslint-disable-line

  if (fileUrl.match(patt1)) {
    return fileUrl.match(patt1)[1]
  }

  return null
}